/////////////////////////Running Code:::::::::::::::::::::::::::::::::
// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../ViewAttendance/ViewAttendance.module.scss';
// import { teamAttendance } from './../../API/API';
// import './TeamAttendance.scss';

// const ViewAttendance = () => {
  //   const [attendanceData, setAttendanceData] = useState([]);
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [openDrawer, setOpenDrawer] = useState(false);

//   useEffect(() => {
  //     const fetchData = async () => {
    //       const userID = localStorage.getItem('userID');
//       const data = JSON.parse(localStorage.getItem('data'));

//       if (userID !== null) {
//         const currentDate = new Date().toISOString().substring(0, 10);
//          const thirtyDaysAgo = new Date();
//         // thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
//         const startDate = thirtyDaysAgo.toISOString().substring(0, 10);

//         try {
//           const employeeIds = ['SI54357']; 
//           const promises = employeeIds.map(empId => teamAttendance(data.token, userID,data.empid ));
//           const responses = await Promise.all(promises);
//           const combinedAttendanceData = responses.flatMap(response => response.data);
//           setAttendanceData(combinedAttendanceData);
//         } catch (error) {
//           toast.error(error.message || 'Failed to fetch attendance data', {
//             icon: '❗',
//             duration: 4500
//           });
//         }
//       }
//     };

//     fetchData();
//   }, []);

//   const handleChangeDate = async (event) => {
  //     event.preventDefault();
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));

//     try {
//       const employeeIds = ['SI54357','SI44510']; 
//       const promises = employeeIds.map(empId => teamAttendance(data.token,userID,data.empid ));
//       const responses = await Promise.all(promises);
//       const combinedAttendanceData = responses.flatMap(response => response.data);
//       setAttendanceData(combinedAttendanceData);

//       setOpenDrawer(false);
//       toast.success(`Attendance From ${fromDate} To ${toDate}`, {
//         duration: 4000
//       });
//     } catch (error) {
//       toast.error(error.message, {
//         icon: '❗',
//         duration: 4500
//       });
//     }
//   }

//   return (
//     <>
//       <BreadCrumb name="View Attendance" />
//       {/* <div className={classes.OpenDrawer}>
//         <p>Set Date to View Attendance</p>
//         <span className='material-icons icons' onClick={() => setOpenDrawer(!openDrawer)}>
//           expand_more
//         </span>
//       </div> */}
//       <div className={classes.ViewAttendance}>
//         {/* {openDrawer && (
//           <div className={classes.InputDiv}>
//             <div className={classes.Inputs}>
//               <label htmlFor="fromDate">
//                 <h2>From Date</h2>
//               </label>
//               <input type="date" name='fromDate' min='2021-01-01' max={toDate} value={fromDate} onChange={(event) => setFromDate(event.target.value)} />
//               <label htmlFor="toDate">
//                 <h2>To Date</h2>
//               </label>
//               <input type="date" name='maxDate' min='2021-01-01' max={new Date().toISOString().substring(0, 10)} value={toDate} onChange={(event) => setToDate(event.target.value)} />
//             </div>
//             <button onClick={handleChangeDate}>
//               View Attendance
//             </button>
//           </div>  
//         )} */}

//         <div className={classes.AttendanceDiv}>       
//           <div className={classes.TableDiv}>         
//             <table cellSpacing={0}>
//               <thead>

//                 <tr>
//                   <th>Employee Name/Designation</th>
//                   <th></th>
//                   <th>Check In Time</th>
//                   <th>Check Out Time</th>

//                 </tr>
//               </thead>
//               <tbody>
//                 {attendanceData.map((item, index) => (
  //                   <tr key={index}>
//                     <td>{item.nd}</td>
//                     <td>{item.dt}</td>

//                     {/* <td style={{ color: item.in_from === '' ? '#EA6A47' :  (item.holiday === 'GH' ? '#FFFF00' : '') }}>{item.in_time || 'Absent'}</td>
//                     <td style={{ color: item.out_from === '' ? '#EA6A47' :  (item.holiday === 'GH' ? '#FFFF00' : '') }}>{ item.in_time ? item.out_time ? item.out_time:'Not Checked Out' : 'Absent'}</td> */}

//                     <td style={{ color: item.in_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '')}}>
//                               {item.in_time || 'Absent'}</td>
//                     <td style={{ color: item.out_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '')}}>
//                               { item.in_time ? (item.out_time ? item.out_time : 'Not Checked Out') : 'Absent'}</td>

//                     {/* <td>{item.in_time || 'Not Checked In'}</td>
//                     <td>{item.out_time || 'Not Checked Out'}</td> */}
//                   </tr>

//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ViewAttendance;


///////////////////////////////////////////Updated Running Code::::::::::::::::::::::

import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
import classes from '../ViewAttendance/ViewAttendance.module.scss';
import { teamAttendance } from './../../API/API';
import './TeamAttendance.scss';

const ViewAttendance = () => {
  const [attendanceData, setAttendanceData] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data') || '{}');

    if (userID && data?.token && data?.empid) {
      try {
        const response = await teamAttendance(data.token, userID, data.empid);
        setAttendanceData(response?.data || []);
      } catch (error) {
        toast.error(error.message || 'Failed to fetch initial attendance data', {
          icon: '❗',
          duration: 4500
        });
      }
    }
  };

  const handleChangeDate = async (event) => {
    event.preventDefault();
    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data') || '{}');

    try {
      const employeeIds = ['SI54357', 'SI44510'];
      const promises = employeeIds.map(empId => teamAttendance(data.token, userID, empId));
      const responses = await Promise.all(promises);
      const combinedAttendanceData = responses.flatMap(response => response?.data || []);
      setAttendanceData(combinedAttendanceData);

      setOpenDrawer(false);
      toast.success(`Attendance From ${fromDate} To ${toDate}`, {
        duration: 4000
      });
    } catch (error) {
      toast.error(error.message || 'Error fetching date-filtered data', {
        icon: '❗',
        duration: 4500
      });
    }
  };

  const handleViewFullAttendance = async () => {
    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data') || '{}');

    try {
      const response = await teamAttendance(data.token, userID, data.empid, 'full');
      setAttendanceData(response?.data || []);
      toast.success("Full attendance loaded successfully!", { duration: 4000 });
    } catch (error) {
      toast.error(error.message || 'Failed to fetch full attendance', {
        icon: '❗',
        duration: 4500
      });
    }
  };

  const getColor = (value, dayType, isCheckIn = true) => {
    if (!value) return '#EA6A47'; // Red for absent or missing value
    if (dayType === 'GH') return '#FF9900'; // Orange for holiday
    if (['Saturday', 'Sunday'].includes(dayType)) return '#FFFF00'; // Yellow for weekends
    return ''; // Default
  };

  return (
    <>
      <BreadCrumb name="View Attendance" />
      <div className={classes.ViewAttendance}>
        <div className={classes.AttendanceDiv}>
          <div className={classes.TableDiv}>
            <table cellSpacing={0}>
              <thead>
                <tr>
                  <th>Employee Name/Designation</th>
                  <th>Check In Time</th>
                  <th>Check Out Time</th>
                </tr>
              </thead>
              <tbody>
                {attendanceData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.nd}</td>
                    <td style={{ color: getColor(item.in_time, item.holiday || item.dt) }}>
                      {item.in_time || 'Absent'}
                    </td>
                    <td style={{ color: getColor(item.out_time, item.holiday || item.dt) }}>
                      {item.in_time ? (item.out_time || 'Not Checked Out') : 'Absent'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <br />
            <button onClick={handleViewFullAttendance} className="view-full-btn">            
              View Full Attendance
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewAttendance;



// import React, { useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from '../ViewAttendance/ViewAttendance.module.scss';
// import { teamAttendance } from './../../API/API';
// import './TeamAttendance.scss';

// const ViewAttendance = () => {
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [openDrawer, setOpenDrawer] = useState(false);
  
//   useEffect(() => {
//     fetchInitialData();
//   }, []);
  
//   const fetchInitialData = async () => {
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
    
//     if (userID !== null && data?.token && data?.empid) {
//       try {
//         const response = await teamAttendance(data.token, userID, data.empid);
//         setAttendanceData(response.data || []);
//       } catch (error) {
//         toast.error(error.message || 'Failed to fetch initial attendance data', {
//           icon: '❗',
//           duration: 4500
//         });
//       }
//     }
//   };
  
//   const handleChangeDate = async (event) => {
//     event.preventDefault();
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
    
//     try {
//       const employeeIds = ['SI54357', 'SI44510'];
//       const promises = employeeIds.map(empId => teamAttendance(data.token, userID, empId));
//       const responses = await Promise.all(promises);
//       const combinedAttendanceData = responses.flatMap(response => response.data);
//       setAttendanceData(combinedAttendanceData);
      
//       setOpenDrawer(false);
//       toast.success(`Attendance From ${fromDate} To ${toDate}`, {
//         duration: 4000
//       });
//     } catch (error) {
//       toast.error(error.message, {
//         icon: '❗',
//         duration: 4500
//       });
//     }
//   };
  
//   const handleViewFullAttendance = async () => {
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
    
//     try {
//       const response = await teamAttendance(data.token, userID, data.empid, 'full');   /////here the new function is added
//       setAttendanceData(response.data || []);
//       toast.success("Full attendance loaded successfully!", { duration: 4000 });
//     } catch (error) {
//       toast.error(error.message || 'Failed to fetch full attendance', {
//         icon: '❗',
//         duration: 4500
//       });
//     }
//   };
  
//   return (
//     <>
//     <BreadCrumb name="View Attendance" />
//     <div className={classes.ViewAttendance}>
         
//       <div className={classes.AttendanceDiv}>
//       <div className={classes.TableDiv}>
//       <table cellSpacing={0}>
//       <thead>
//       <tr>
//       <th>Employee Name/Designation</th>
//       {/* <th>Date</th> */}
//       <th>Check In Time</th>
//       <th>Check Out Time</th>
//       </tr>
//       </thead>
//       <tbody>
//         {attendanceData.map((item, index) => (
//           <tr key={index}>
//           <td>{item.nd}</td>
//           <td>{item.dt}</td>
//           <td style={{ color: item.in_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
//           {item.in_time || 'Absent'}
          
          
//           </td>
//           <td style={{ color: item.out_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
//           {item.in_time ? (item.out_time ? item.out_time : 'Not Checked Out') : 'Absent'}
          
//           </td>
//           </tr>
//         ))}
//         </tbody>
        
//         </table>
//         <br></br>
//         <button onClick={handleViewFullAttendance} className="view-full-btn">
//         View Full Attendance
//         </button> 
//         </div>
//         </div>
//         </div>
//         </>
//       );
//     };
    
//     export default ViewAttendance;





    
    
    
    
    
    
    // import React from 'react';
    // import toast from 'react-hot-toast';
    // import { teamAttendance } from '../../API/API'; // Adjust the path as needed
    
    // const FullAttendanceButton = ({ setAttendanceData }) => {
      //   const handleFetchFullAttendance = async () => {
        //     const userID = localStorage.getItem('userID');
    //     const data = JSON.parse(localStorage.getItem('data'));
    
    //     if (!userID || !data?.token) {
    //       toast.error('User not logged in properly');
    //       return;
    //     }
    
    //     try {
    //       const employeeIds = ['SI54357', 'SI44510']; // Add more if needed
    //       const promises = employeeIds.map(empId =>
      //         teamAttendance(data.token, userID, empId)
    //       );
    //       const responses = await Promise.all(promises);
    //       const combinedAttendanceData = responses.flatMap(response => response.data);
    //       setAttendanceData(combinedAttendanceData);
    //       toast.success('Team attendance fetched successfully!');
    //     } catch (error) {
    //       toast.error(error.message || 'Failed to fetch team attendance');
    //     }
    //   };
    
    //   return (
    //     <button className="team-attendance-btn" onClick={handleFetchFullAttendance}>
    //       Fetch Team Attendance
    //     </button>
    //   );
    // };
    
    // export default FullAttendanceButton;
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    // import React from 'react';
    // import toast from 'react-hot-toast';
    // //import { teamAttendance } from '../API/API'; // ✅ Adjust the path as per your structure
    // import { teamAttendance } from './../../API/API';
    // //import './FullAttendanceButton.scss'; // ✅ Optional: Add styles if you want
    // import './TeamAttendance.scss';
    // const FullAttendanceButton = ({ setAttendanceData }) => {
      //   const handleFetchFullAttendance = async () => {
        //     const userID = localStorage.getItem('userID');
    //     const data = JSON.parse(localStorage.getItem('data'));
    
    //     if (!userID || !data?.token) {
    //       toast.error('User not logged in or token missing');
    //       return;
    //     }
    
    //     try {
    //       const employeeIds = ['SI54357', 'SI44510']; // You can make this dynamic later
    //       const promises = employeeIds.map(empId =>
      //         teamAttendance(data.token, userID, empId, 'full') // ✅ Sending 'full' as parameter
    //       );
    //       const responses = await Promise.all(promises);
    //       const combinedAttendanceData = responses.flatMap(response => response.data);
    
    //       setAttendanceData(combinedAttendanceData);
    //       toast.success('Full attendance data fetched successfully', { duration: 4000 });
    //     } catch (error) {
    //       toast.error(error.message || 'Failed to fetch full data', {
    //         icon: '❗',
    //         duration: 4500
    //       });
    //     }
    //   };
    
    //   return (
    //     <button className="fetchFullBtn" onClick={handleFetchFullAttendance}>
    //       View all
    //     </button>
    //   );
    // };
    
    // export default FullAttendanceButton;
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    // import React, { useEffect, useState } from 'react';
    // import toast from 'react-hot-toast';
    // import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
    // import classes from '../ViewAttendance/ViewAttendance.module.scss';
    // import { teamAttendance } from './../../API/API';
    // import './TeamAttendance.scss';
    
    // const ViewAttendance = () => {
      //   const [attendanceData, setAttendanceData] = useState([]);
    //   const [fromDate, setFromDate] = useState('');
    //   const [toDate, setToDate] = useState('');
    //   const [openDrawer, setOpenDrawer] = useState(false);
    //   const [selectedItem, setSelectedItem] = useState(null);
    
    //   useEffect(() => {
      //     const fetchData = async () => {
        //       const userID = localStorage.getItem('userID');
    //       const data = JSON.parse(localStorage.getItem('data'));
    
    //       if (userID !== null) {
    //         const currentDate = new Date().toISOString().substring(0, 10);
    //         const thirtyDaysAgo = new Date();
    //         const startDate = thirtyDaysAgo.toISOString().substring(0, 10);
    
    //         try {
    //           const employeeIds = ['SI54357'];
    //           const promises = employeeIds.map(empId =>
      //             teamAttendance(data.token, userID, empId) // use empId here
    //           );
    //           const responses = await Promise.all(promises);
    //           const combinedAttendanceData = responses.flatMap(response => response.data);
    //           setAttendanceData(combinedAttendanceData);
    //         } catch (error) {
    //           toast.error(error.message || 'Failed to fetch attendance data', {
    //             icon: '❗',
    //             duration: 4500
    //           });
    //         }
    //       }
    //     };
    
    //     fetchData();
    //   }, []);
    
    //   const handleChangeDate = async (event) => {
      //     event.preventDefault();
    //     const userID = localStorage.getItem('userID');
    //     const data = JSON.parse(localStorage.getItem('data'));
    
    //     try {
    //       const employeeIds = ['SI54357', 'SI44510'];
    //       const promises = employeeIds.map(empId =>
      //         teamAttendance(data.token, userID, empId) // use empId here
    //       );
    //       const responses = await Promise.all(promises);
    //       const combinedAttendanceData = responses.flatMap(response => response.data);
    //       setAttendanceData(combinedAttendanceData);
    
    //       setOpenDrawer(false);
    //       toast.success(`Attendance From ${fromDate} To ${toDate}`, {
    //         duration: 4000
    //       });
    //     } catch (error) {
    //       toast.error(error.message, {
    //         icon: '❗',
    //         duration: 4500
    //       });
    //     }
    //   };
    
    //   return (
    //     <>
    //       <BreadCrumb name="View Attendance" />
    
    //       <div className={classes.ViewAttendance}>
    //         <div className={classes.AttendanceDiv}>
    //           <div className={classes.TableDiv}>
    //             <table cellSpacing={0}>
    //               <thead>
    //                 <tr>
    //                   <th>Employee Name/Designation</th>
    //                   <th>Date</th>
    //                   <th>Check In Time</th>
    //                   <th>Check Out Time</th>
    //                   <th>Action</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {attendanceData.map((item, index) => (
      //                   <tr key={index}>
    //                     <td>{item.nd}</td>
    //                     <td>{item.dt}</td>
    //                     <td style={{ color: item.in_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
    //                       {item.in_time || 'Absent'}
    //                     </td>
    //                     <td style={{ color: item.out_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
    //                       {item.in_time ? (item.out_time ? item.out_time : 'Not Checked Out') : 'Absent'}
    //                     </td>
    //                     <td>
    //                       <button onClick={() => setSelectedItem(item)}>View</button>
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           </div>
    
    //           {/* Full detail view */}
    //           {selectedItem && (
    //             <div className={classes.FullDetails}>
    //               <h3>Full Attendance Details</h3>
    //               <div className={classes.DetailGrid}>
    //                 {Object.entries(selectedItem).map(([key, value]) => (
      //                   <p key={key}>
    //                     <strong>{key}:</strong> {value === null || value === '' ? 'N/A' : value.toString()}
    //                   </p>
    //                 ))}
    //               </div>
    //               <button onClick={() => setSelectedItem(null)}>Close</button>
    //             </div>
    //           )}
    //         </div>
    //       </div>
    //     </>
    //   );
    // };
    
    // export default ViewAttendance;
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    //////////////////////////////////////Testing Code
    
    // import React, { useEffect, useState } from 'react';
    // import toast from 'react-hot-toast';
    // import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
    // import classes from '../ViewAttendance/ViewAttendance.module.scss';
    // import { teamAttendance} from './../../API/API';
    // //import {fullatt} from './../../API/API';
    // import './TeamAttendance.scss';
    
    // const ViewAttendance = () => {
      //   const [attendanceData, setAttendanceData] = useState([]);
    //   const [fromDate, setFromDate] = useState('');
    //   const [toDate, setToDate] = useState('');
    //   const [openDrawer, setOpenDrawer] = useState(false);
    
    //   useEffect(() => {
      //     const fetchData = async () => {
        //       const userID = localStorage.getItem('userID');
    //       const data = JSON.parse(localStorage.getItem('data'));
    
    //       if (userID !== null) {
    //         try {
    //           const employeeIds = ['SI54357'];
    //           const promises = employeeIds.map(empId =>
      //             teamAttendance(data.token, userID, empId)
    //             //fullatt(data.token, userID, empId)
    //           );
    //           const responses = await Promise.all(promises);
    //           const combinedAttendanceData = responses.flatMap(response => response.data);
    //           setAttendanceData(combinedAttendanceData);
    //         } catch (error) {
    //           toast.error(error.message || 'Failed to fetch attendance data', {
    //             icon: '❗',
    //             duration: 4500
    //           });
    //         }
    //       }
    //     };
    
    //     fetchData();
    //   }, []);
    
    //   const handleChangeDate = async (event) => {
      //     event.preventDefault();
    //     const userID = localStorage.getItem('userID');
    //     const data = JSON.parse(localStorage.getItem('data'));
    
    //     try {
    //       const employeeIds = ['SI54357', 'SI44510'];
    //       const promises = employeeIds.map(empId =>
      //         teamAttendance(data.token, userID, empId)
    //         //fullatt(data.token, userID, empId)
    //       );
    //       const responses = await Promise.all(promises);
    //       const combinedAttendanceData = responses.flatMap(response => response.data);
    //       setAttendanceData(combinedAttendanceData);
    
    //       setOpenDrawer(false);
    //       toast.success(`Attendance From ${fromDate} To ${toDate}`, {
    //         duration: 4000
    //       });
    //     } catch (error) {
    //       toast.error(error.message, {
    //         icon: '❗',
    //         duration: 4500
    //       });
    //     }
    //   };
    
    //   const handleViewFullAttendance = async (empId) => {
      //     const userID = localStorage.getItem('userID');
    //     const data = JSON.parse(localStorage.getItem('data'));
    
    //     try {
    //       const response = await fullatt(data.token, userID, empId);
    //       const detailedData = response?.data || [];
    
    //       console.log(`Full attendance for ${empId}:`, detailedData);
    //       toast.success(`Fetched full attendance for ${empId}`, { duration: 4000 });
    //     } catch (error) {
    //       toast.error(`Error fetching full data for ${empId}`, {
    //         icon: '❗',
    //         duration: 4500
    //       });
    //     }
    //   };
    
    //   return (
    //     <>
    //       <BreadCrumb name="View Attendance" />
    //       <div className={classes.ViewAttendance}>
    //         <div className={classes.AttendanceDiv}>
    //           <div className={classes.TableDiv}>
    //             <table cellSpacing={0}>
    //               <thead>
    //                 <tr>
    //                   <th>Employee Name/Designation</th>
    //                   <th>Date</th>
    //                   <th>Check In Time</th>
    //                   <th>Check Out Time</th>
    //                   <th>Action</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {attendanceData.map((item, index) => (
      //                   <tr key={index}>
    //                     <td>{item.nd}</td>
    //                     <td>{item.dt}</td>
    //                     <td style={{ color: item.in_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
    //                       {item.in_time || 'Absent'}
    //                     </td>
    //                     <td style={{ color: item.out_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
    //                       {item.in_time ? (item.out_time ? item.out_time : 'Not Checked Out') : 'Absent'}
    //                     </td>
    //                     <td>
    //                       <button className="view-button" onClick={() => handleViewFullAttendance(item.empId)}>    
    //                         View
    //                       </button>
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           </div>
    //         </div>
    //       </div>
    //     </>
    //   );
    // };
    
    // export default ViewAttendance;
    
    
    
    
    
    
    
    
    
    
    
    
    
    //////////////////////////////////////////////////////////////////Testing Code::::::::::::::::::::::::::::::
    
    // import React, { useEffect, useState } from 'react';
    // import toast from 'react-hot-toast';
    // import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
    // import classes from '../ViewAttendance/ViewAttendance.module.scss';
    // import { teamAttendance } from './../../API/API';
    // import './TeamAttendance.scss';
    
    // const ViewAttendance = () => {
      //   const [attendanceData, setAttendanceData] = useState([]);
    //   const [fullData, setFullData] = useState([]);
    //   const [showFullData, setShowFullData] = useState(false);
    //   const [selectedEmpName, setSelectedEmpName] = useState('');
    
    //   useEffect(() => {
      //     const fetchData = async () => {
        //       const userID = localStorage.getItem('userID');
    //       const data = JSON.parse(localStorage.getItem('data'));
    
    //       if (userID !== null) {
    //         const currentDate = new Date().toISOString().substring(0, 10);
    //         const thirtyDaysAgo = new Date();
    //         const startDate = thirtyDaysAgo.toISOString().substring(0, 10);
    
    //         try {
    //           const employeeIds = ['SI54357'];
    //           const promises = employeeIds.map(empId =>
      //             teamAttendance(data.token, userID, empId)
    //           );
    //           const responses = await Promise.all(promises);
    //           const combinedAttendanceData = responses.flatMap(response => response.data);
    //           setAttendanceData(combinedAttendanceData);
    //         } catch (error) {
    //           toast.error(error.message || 'Failed to fetch attendance data', {
    //             icon: '❗',
    //             duration: 4500
    //           });
    //         }
    //       }
    //     };
    
    //     fetchData();
    //   }, []);
    
    //   const handleViewFullDetails = async (empId, empName) => {
      //     const userID = localStorage.getItem('userID');
    //     const data = JSON.parse(localStorage.getItem('data'));
    
    //     try {
    //       const response = await teamAttendance(data.token, userID, empId, 'full');
    //       setFullData(response.data);
    //       setSelectedEmpName(empName);
    //       setShowFullData(true);
    //       toast.success("Full Attendance Loaded");
    //     } catch (error) {
    //       toast.error(error.message || "Failed to fetch full data");
    //     }
    //   };
    
    //   return (
    //     <>
    //       <BreadCrumb name="View Attendance" />
    
    //       <div className={classes.ViewAttendance}>
    //         <div className={classes.AttendanceDiv}>
    //           <div className={classes.TableDiv}>
    //             <table cellSpacing={0}>
    //               <thead>
    //                 <tr>
    //                   <th>Employee Name/Designation</th>
    //                   <th>Date</th>
    //                   <th>Check In Time</th>
    //                   <th>Check Out Time</th>
    //                   <th>Action</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {attendanceData.map((item, index) => (
      //                   <tr key={index}>
    //                     <td>{item.nd}</td>
    //                     <td>{item.dt}</td>
    //                     <td style={{ color: item.in_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
    //                       {item.in_time || 'Absent'}
    //                     </td>
    //                     <td style={{ color: item.out_from === '' ? '#EA6A47' : (item.holiday === 'GH' || ['Saturday', 'Sunday'].includes(item.dt) ? '#FFFF00' : '') }}>
    //                       {item.in_time ? (item.out_time ? item.out_time : 'Not Checked Out') : 'Absent'}
    //                     </td>
    //                     <td>
    //                       <button
    //                         className="viewButton"
    //                         onClick={() => handleViewFullDetails(item.emp_id, item.nd)}
    //                       >
    //                         View
    //                       </button>
    //                     </td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           </div>
    //         </div>
    
    //         {/* Full Attendance Detail View */}
    //         {showFullData && fullData.length > 0 && (
    //           <div className="FullDataSection">
    //             <h3>Full Attendance Details for {selectedEmpName}</h3>
    //             <table>
    //               <thead>
    //                 <tr>
    //                   <th>Date</th>
    //                   <th>Check-In</th>
    //                   <th>Check-Out</th>
    //                   <th>Status</th>
    //                 </tr>
    //               </thead>
    //               <tbody>
    //                 {fullData.map((record, i) => (
      //                   <tr key={i}>
    //                     <td>{record.dt}</td>
    //                     <td>{record.in_time || 'Absent'}</td>
    //                     <td>{record.out_time || 'Absent'}</td>
    //                     <td>{record.status || '-'}</td>
    //                   </tr>
    //                 ))}
    //               </tbody>
    //             </table>
    //           </div>
    //         )}
    //       </div>
    //     </>
    //   );
    // };
    
    // export default ViewAttendance;
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    